import { encodeQuery, history } from 'utils';

export const getRedirectLocation = () => {
  const query = encodeQuery.parseQuery(history.location.search);
  if (query.request_token) {
    return `${query.redirect_location}&request_token=${query.request_token}`;
  }
  return query.redirect_location;
};
